import { InjectionToken } from '@angular/core';

export const EMS_API_SERVER_URL = new InjectionToken<string>('EMS web api server url');


